import { RandomGenerator } from '../../test-utils';
var TeamBuilder = /** @class */ (function () {
    function TeamBuilder() {
        var name = RandomGenerator.randomString();
        var id = RandomGenerator.randomString();
        var now = Date.now();
        this.team = {
            name: name, id: id,
            creationDate: now, lastUpdateDate: now
        };
    }
    TeamBuilder.prototype.withTeamId = function (id) {
        this.team.id = id;
        return this;
    };
    TeamBuilder.prototype.withName = function (name) {
        this.team.name = name;
        return this;
    };
    TeamBuilder.prototype.withCreationDate = function (creationDate) {
        this.team.creationDate = creationDate;
        return this;
    };
    TeamBuilder.prototype.withLastUpdateDate = function (lastUpdateDate) {
        this.team.lastUpdateDate = lastUpdateDate;
        return this;
    };
    TeamBuilder.prototype.build = function () {
        return this.team;
    };
    return TeamBuilder;
}());
export { TeamBuilder };
//# sourceMappingURL=team.builder.js.map